import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import useAuth from "@/hooks/useAuth";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      staleTime: 5 * 1000,
    },
  },
});

interface IProps {
  children: React.ReactNode;
}

export const ReactQueryProvider: React.FC<IProps> = ({ children }) => {
  const { isInitialized } = useAuth();

  React.useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe(() => {
      // Pause all queries when not initialized
      // This is important to make sure we send the auth token with the requests
      queryClient.setDefaultOptions({
        queries: { enabled: isInitialized },
      });
    });

    return () => {
      unsubscribe();
    };
  }, [isInitialized]);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
